export function renderLoginPage(): string {
  return `
    <section class="screen">
      <div class="hero-card">
        <p class="eyebrow">消防验收报告助手</p>
        <h1>登录并进入项目</h1>
        <p class="muted">普通用户按账号进入本组项目；管理员可登录后添加、删除用户。</p>
      </div>
      <div class="login-grid">
        <form id="user-login-form" class="panel stack">
          <div>
            <h2>用户登录</h2>
            <p class="muted">输入姓名和密码后进入本组项目。</p>
          </div>
          <label class="field">
            <span>姓名</span>
            <input name="name" type="text" placeholder="请输入姓名" maxlength="24" required />
          </label>
          <label class="field">
            <span>密码</span>
            <input name="password" type="password" placeholder="请输入密码" maxlength="32" required />
          </label>
          <button class="primary-button" type="submit">进入项目</button>
        </form>
        <form id="admin-login-form" class="panel stack">
          <div>
            <h2>管理员登录</h2>
            <p class="muted">管理员可维护普通用户和分组。</p>
          </div>
          <label class="field">
            <span>账号</span>
            <input name="account" type="text" placeholder="请输入管理员账号" maxlength="32" required />
          </label>
          <label class="field">
            <span>密码</span>
            <input name="password" type="password" placeholder="请输入管理员密码" maxlength="32" required />
          </label>
          <button class="ghost-button" type="submit">进入管理</button>
        </form>
      </div>
      <p id="login-error" class="login-error" hidden></p>
    </section>
  `;
}
